import React from "react";
import { NavLink } from "react-router-dom";

export default function DigitalizationProcessAutomation() {
  return (
    <section className="container page-top pt-10" style={{ paddingTop: "6rem" }}>
      <div className="container">
        {/* Title Section */}
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h1 className="display-5 fw-bold text-primary">Digitalization & Process Automation</h1>
            <h5 className="text-muted">
              Streamline Operations and Boost Efficiency with Smart Automation Solutions
            </h5>
            <hr className="w-25 mx-auto" />
          </div>
        </div>

        {/* Image and Introduction */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <img
              src="https://img.freepik.com/free-vector/automation-concept-illustration_114360-1517.jpg"
              alt="Digitalization and Process Automation"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6">
            <h2 className="fw-semibold">Why Digitalize and Automate?</h2>
            <p>
              <strong>Bytlas Intelligence</strong> empowers your business to transform manual, repetitive tasks into automated workflows. Our digitalization services increase productivity, reduce errors, and free your workforce to focus on strategic goals.
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ End-to-End Business Process Automation</li>
              <li className="list-group-item">✅ Integration with Existing Systems</li>
              <li className="list-group-item">✅ Real-Time Monitoring and Analytics</li>
              <li className="list-group-item">✅ Scalable and Secure Solutions</li>
            </ul>
          </div>
        </div>

        {/* Features Section */}
        <div className="row my-5">
          <div className="col-md-6">
            <h3 className="text-secondary">Our Automation Solutions</h3>
            <p>
              We design custom automation tools including Robotic Process Automation (RPA), AI-powered decision-making, and digital workflows that fit your unique business needs.
            </p>
            <p>
              Automate tasks such as data entry, invoicing, customer onboarding, and report generation to increase efficiency and reduce costs.
            </p>
          </div>

          <div className="col-md-6">
            <h3 className="text-secondary">Benefits You Gain</h3>
            <ul>
              <li>⚙️ Reduced Operational Costs</li>
              <li>⏱ Faster Turnaround Times</li>
              <li>🔍 Enhanced Data Accuracy and Compliance</li>
              <li>📈 Improved Employee Productivity</li>
              <li>🌐 Seamless Integration Across Departments</li>
            </ul>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-4">
          <NavLink to="/contact" className="btn btn-danger px-4 py-2 rounded-pill fw-bold">
            Schedule Your Automation Consultation
          </NavLink>
        </div>
      </div>
    </section>
  );
}
